import { DateHelper } from "@swivl-mono/helpers";
import { ReviewInterface, ReviewPlatform } from "@swivl-mono/types";

import { ReviewView } from "../Review/Review.View";

export interface ReviewsManagerViewFilters {
  responded: boolean;
  notResponded: boolean;
  starRating1: boolean;
  starRating2: boolean;
  starRating3: boolean;
  starRating4: boolean;
  starRating5: boolean;

  google: boolean;
  yelp: boolean;
  spot: boolean;

  stores: { [key: number]: boolean };
}
export interface ReviewsManagerViewFilterCounts {
  responded: number;
  notResponded: number;
  starRating1: number;
  starRating2: number;
  starRating3: number;
  starRating4: number;
  starRating5: number;

  google: number;
  yelp: number;
  spot: number;

  stores: { [id: number]: number };

  total: number;
  filtered: number;
  selected: number;
  selectableRows: { [id: number]: ReviewInterface };
}
export const blankReviewCounts: ReviewsManagerViewFilterCounts = {
  responded: 0,
  notResponded: 0,
  starRating1: 0,
  starRating2: 0,
  starRating3: 0,
  starRating4: 0,
  starRating5: 0,

  google: 0,
  yelp: 0,
  spot: 0,

  stores: {},

  total: 0,
  filtered: 0,
  selected: 0,
  selectableRows: {},
};

export function getReviewsViewData(reviews: ReviewInterface[], filters: ReviewsManagerViewFilters, selectedReviews, showMultiSelect) {
  var _counts: ReviewsManagerViewFilterCounts = { ...blankReviewCounts };

  if (!reviews) return { reviewViews: [], storesWithReviews: [], filtersSelected: false, counts: _counts };

  var starFilters: number[] = [];
  [filters.starRating1, filters.starRating2, filters.starRating3, filters.starRating4, filters.starRating5].forEach((value, index) => {
    if (value) starFilters.push(index + 1);
  });

  var filteringPlatform: ReviewPlatform[] = [];
  if (filters.google) {
    filteringPlatform.push(ReviewPlatform.GOOGLE);
  }
  if (filters.yelp) {
    filteringPlatform.push(ReviewPlatform.YELP);
  }
  if (filters.spot) {
    filteringPlatform.push(ReviewPlatform.SPOT);
  }
  var storeFilters: number[] = Object.keys(filters.stores)
    .filter((storeId) => filters.stores[storeId])
    .map((storeId) => parseInt(storeId));

  var _reviewViews: any = [];
  var _storesWithReviewsById = {};




  _counts.stores = {};
  reviews
    .sort((a, b) => DateHelper.normalize(b.reviewDate).getTime() - DateHelper.normalize(a.reviewDate).getTime())
    .forEach((review: ReviewInterface) => {
      // const tableKey = locationsMapKeyForReview(review);
      const locationId = review.locationId;
      if (!location) {
        console.warn("missing location :", review, locationId);
      }

      _counts.total++;
      if (review.replyText) {
        _counts.responded++;
      } else {
        _counts.notResponded++;
      }
      if (review.rating === 1) {
        _counts.starRating1++;
      }
      if (review.rating === 2) {
        _counts.starRating2++;
      }
      if (review.rating === 3) {
        _counts.starRating3++;
      }
      if (review.rating === 4) {
        _counts.starRating4++;
      }
      if (review.rating === 5) {
        _counts.starRating5++;
      }
      if (review.platform === ReviewPlatform.GOOGLE) {
        _counts.google++;
      }
      if (review.platform === ReviewPlatform.YELP) {
        _counts.yelp++;
      }
      if (review.platform === ReviewPlatform.SPOT) {
        _counts.spot++;
      }

      if (location) {
        if (_counts.stores[locationId] === undefined) {
          _counts.stores[locationId] = 0;
        }
        _counts.stores[locationId]++;
      }

      var includeReview = true;
      if (review.platform === ReviewPlatform.GOOGLE && (review.locationLookupId === undefined || !review?.locationLookupId?.length || !location)) {
        includeReview = false; // skip reviews without a provider id
      }

      if (!(filters.responded && filters.notResponded)) {
        if (filters.responded && !review.replyText) {
          includeReview = false;
        }
        if (filters.notResponded && review.replyText) {
          includeReview = false;
        }
      }

      if (starFilters?.length) {
        if (!starFilters.includes(review.rating)) {
          includeReview = false;
        }
      }
      if (filteringPlatform?.length) {
        if (!filteringPlatform.includes(review.platform)) {
          includeReview = false;
        }
      }
      if (storeFilters?.length) {
        if (!location || !storeFilters.includes(review.locationId)) {
          includeReview = false;
        }
      }

      if (includeReview) {
        _counts.filtered++;
        const selected = selectedReviews[review.id] !== undefined;
        if (selected) {
          _counts.selected++;
        }
        _counts.selectableRows[review.id] = review;
        _reviewViews.push(<ReviewView key={review.id} review={review} selected={selected} showingMultiSelect={showMultiSelect} />);
      }

      if (location && locationId) {
        _storesWithReviewsById[locationId] = location;
      }
    });

  return {
    reviewViews: _reviewViews,
    counts: _counts,
    storesWithReviews: [],
  };
} //, [reviews, locationsMap, filters, selectedReviews, showMultiSelect]);
